import { render, staticRenderFns } from "./WidgetColorSelect.vue?vue&type=template&id=2f613208&scoped=true&"
import script from "./WidgetColorSelect.vue?vue&type=script&lang=ts&"
export * from "./WidgetColorSelect.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetColorSelect.vue?vue&type=style&index=0&id=2f613208&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f613208",
  null
  
)

export default component.exports